import axios from "axios";

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      
      return response;
    },
    (error) => {
   
      if (error.response && error.response.status === 401) {
      
        localStorage.removeItem("user");

        
        window.location.hash = "/login";
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
